import type { ProgressReportStore } from '../model/store/interfaces'

import { isFullArray } from '@shared/lib/collections'

import { getReport } from './report'

const getAchievements = (state: ProgressReportStore): string[] => getReport(state)?.achievements || []

export const achievements = {
  getAchievements: (state: ProgressReportStore): string[] => getAchievements(state),
  hasAchievements: (state: ProgressReportStore): boolean => isFullArray(getAchievements(state)),
}
